import { Card, Button, defaultTheme, Input, LoginContext, NamedContext } from '@2r/frontend-component-library';
import { ThemeProvider } from '@emotion/react';
import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from 'reactstrap';
import { NavMenu } from '../components/NavMenu';

export function Login() {
    const [status, setStatus] = useState('');
    const navigate = useNavigate();
    const ctx = useContext<LoginContext>(LoginContext);

    const [credentials, setCredentials] = useState({
        Username: '',
        Password: ''
    });

    function setUsername(name: string) {
        setCredentials({
            ...credentials,
            Username: name
        });

        return true;
    }

    function setPassword(pass: string) {
        setCredentials({
            ...credentials,
            Password: pass
        });

        return true;
    }

    async function login() {
        setStatus('Loading...');

        const response = await fetch('/login/token', {
            method: 'POST',
            body: JSON.stringify(credentials),
            headers: {
                "Content-Type": "application/json",
            }
        });

        if (response.ok) {
            const json = await response.json();
            
            const token = json.token;

            ctx.setToken(token);
            ctx.onLogin(token);

            navigate('/');
        } else {
            setStatus("Login war nicht erfolgreich!");

            return false;
        }
    }

    return (
        <ThemeProvider theme={defaultTheme}>
            <NamedContext Name="synqo.cloud">
                <NavMenu minimal />
                <Container>
                    <Card Label="Login" Name="Login">
                        <Input<string>
                            Name="Username"
                            Label="Nutzername"
                            value={credentials.Username}
                            onChange={setUsername}
                        />
                        <Input<string>
                            Name="Passwort"
                            Label="Passwort"
                            type="password"
                            value={credentials.Password}
                            onChange={setPassword}
                        />
                        <Button Name="Login" Label="Login" onClick={login} locked={status === 'Loading...'} />
                        <div>{status}</div>
                    </Card>
                </Container>
            </NamedContext>
        </ThemeProvider>
    );
}
